export default "__VITE_ASSET__4d45c8bb__"